import { render, staticRenderFns } from "./eventnews.vue?vue&type=template&id=8934328a&scoped=true"
import script from "./eventnews.vue?vue&type=script&lang=js"
export * from "./eventnews.vue?vue&type=script&lang=js"
import style0 from "./eventnews.vue?vue&type=style&index=0&id=8934328a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8934328a",
  null
  
)

export default component.exports